import Vue from 'vue'
import axios from 'axios'
import App from './App.vue'
import store from '@/store'
import VueMask from 'v-mask'
import routes from '@/routes'
import vSelect from 'vue-select'
import VueRouter from 'vue-router'
import Sweet from '@/assets/js/sweet'
import 'vue-select/dist/vue-select.css'
import Funcoes from '@/assets/js/functions'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@/assets/css/modal-fixes.css'
import '@/assets/css/ibcgp-footer.css'
import { modalMixin } from '@/mixins/modalMixin'
import { setupGuards } from '@/router/guards'

import "@fortawesome/fontawesome-free/css/all.min.css";

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

const city = 'concursos'
Vue.prototype.$city = city

Vue.prototype.$siteInstituto = 'https://ibcgp.org.br'

//const baseApiURL =  'http://localhost:2500' 
const baseApiURL =  'https://api.ibcgp.org.br' 
axios.defaults.baseURL = baseApiURL

// Configurar header Access padrão para rotas do PS
axios.defaults.headers.common['Access'] = 'ps'

// Interceptor para adicionar token automaticamente
axios.interceptors.request.use(
  (config) => {
    // Garantir que o header Access está presente
    if (!config.headers['Access']) {
      config.headers['Access'] = 'ps'
    }
    
    // Rotas que requerem token auditor (middleware auditor.ps)
    const isAuditoriaApiRoute = config.url && config.url.includes('/ps/auditoria/')

    // Rotas que requerem token admin (middleware admin.ps)
    const isAdminRoute = config.url && (
      config.url.includes('/admin/') || 
      config.url.includes('/admin/logout') ||
      config.url.includes('/admin/refresh') ||
      config.url.includes('/admin/trocar-senha') ||
      config.url.includes('/admin/criar') ||
      config.url.includes('/admin/atualizar/') ||
      config.url.includes('/admin/excluir/') ||
      config.url.includes('/concurso/admin/') ||
      config.url.includes('/concurso/criar') ||
      config.url.includes('/concurso/atualizar/') ||
      config.url.includes('/concurso/deletar/') ||
      config.url.includes('/concurso/vaga/') ||
      config.url.includes('/concurso/publicacao/') ||
      config.url.includes('/concurso/convenio/') ||
      config.url.includes('/candidato/admin/') ||
      config.url.includes('/inscricao/admin/') ||
      config.url.includes('/inscricao/concurso/') ||
      config.url.includes('/isencao/admin/') ||
      config.url.includes('/isencao/concurso/') ||
      config.url.includes('/recurso/admin/') ||
      config.url.includes('/recurso/concurso/') ||
      config.url.includes('/envio/admin/') ||
      config.url.includes('/envio/concurso/') ||
      config.url.includes('/boleto/admin/') ||
      config.url.includes('/logs') ||
      config.url.includes('/reembolso/admin/') ||
      config.url.includes('/documento-inscricao/admin/')
    )

    // Rotas que requerem token de candidato (middleware access.validate)
    const isCandidateRoute = config.url && (
      config.url.includes('/candidato/alterar-dados') ||
      config.url.includes('/candidato/trocar-senha') ||
      config.url.includes('/inscricao/') && !config.url.includes('/admin/') && !config.url.includes('/concurso/') ||
      config.url.includes('/isencao/inscricao') ||
      config.url.includes('/isencao/') && config.url.match(/\/isencao\/\d+\/solicitar/) ||
      config.url.includes('/isencao/') && config.url.match(/\/isencao\/\d+$/) ||
      config.url.includes('/recurso/inscricao/') ||
      config.url.includes('/recurso/') && config.url.match(/\/recurso\/\d+\/registrar/) ||
      config.url.includes('/recurso/') && config.url.match(/\/recurso\/\d+$/) ||
      config.url.includes('/envio/inscricao') ||
      config.url.includes('/envio/') && config.url.match(/\/envio\/\d+\/registrar/) ||
      config.url.includes('/envio/') && config.url.match(/\/envio\/\d+$/) ||
      config.url.includes('/boleto/') && config.url.match(/\/boleto\/\d+$/) ||
      config.url.includes('/boleto/gerar/') ||
      config.url.includes('/boleto/imprimir/') && !config.url.includes('/admin/') ||
      config.url.includes('/reembolso') && !config.url.includes('/admin') ||
      config.url.match(/\/reembolso\/\d+\/solicitar/) ||
      config.url.match(/\/reembolso\/\d+$/) && !config.url.includes('/status') ||
      config.url.includes('/documento-inscricao/') && !config.url.includes('/admin/')
    )
    
    if (isAuditoriaApiRoute) {
      const auditorToken = localStorage.getItem('auditor-token')
      if (auditorToken) {
        config.headers.Authorization = `Bearer ${auditorToken}`
      }
    } else if (isAdminRoute) {
      // Para rotas administrativas, usar token admin
      const adminToken = localStorage.getItem('admin-token')
      if (adminToken) {
        config.headers.Authorization = `Bearer ${adminToken}`
      }
    } else if (isCandidateRoute) {
      // Para rotas de candidato, usar token de candidato
      const candidateToken = localStorage.getItem(`token-${city}`)
      if (candidateToken) {
        config.headers.Authorization = `Bearer ${candidateToken}`
      }
    } else {
      // Para rotas públicas ou outras, tentar admin primeiro, depois candidato
      const adminToken = localStorage.getItem('admin-token')
      if (adminToken) {
        config.headers.Authorization = `Bearer ${adminToken}`
      } else {
        const candidateToken = localStorage.getItem(`token-${city}`)
        if (candidateToken) {
          config.headers.Authorization = `Bearer ${candidateToken}`
        }
      }
    }
    
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Interceptor para tratar respostas de erro
axios.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    if (error.response?.status === 401) {
      // Verificar qual área o usuário está acessando
      const currentPath = window.location.pathname
      const isAdminArea = currentPath.includes('/admin')
      const isAuditoriaArea = currentPath.includes('/auditoria')
      
      // Limpar tokens apropriados
      if (isAuditoriaArea) {
        localStorage.removeItem('auditor-token')
        localStorage.removeItem('auditor-user')
        delete axios.defaults.headers.common['Authorization']
        if (!currentPath.includes('/auditoria/login')) {
          window.location.href = '/auditoria/login'
        }
      } else if (isAdminArea) {
        localStorage.removeItem('admin-token')
        delete axios.defaults.headers.common['Authorization']
        
        // Redirecionar para login admin
        if (!currentPath.includes('/admin/login')) {
          window.location.href = '/admin/login'
        }
      } else {
        // Área do candidato
        localStorage.removeItem(`token-${city}`)
        delete axios.defaults.headers.common['Authorization']
        
        // Redirecionar para login do candidato (home com modal)
        if (window.location.hash !== '#/') {
          window.location.href = '/#/'
          // Recarregar para abrir o modal de login
          setTimeout(() => {
            window.location.reload()
          }, 100)
        }
      }
    }
    return Promise.reject(error)
  }
)

Vue.use(VueMask)
Vue.use(VueRouter)
Vue.prototype.$f = new Funcoes()
Vue.prototype.$sweet = new Sweet()
Vue.component('SelectComp', vSelect)

// Registrar mixin globalmente
Vue.mixin(modalMixin)

const router = new VueRouter({ 
  routes, 
  base: '/',
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

// Configurar guards de navegação
setupGuards(router)

new Vue({
  store,
  router,
  render: (h) => h(App)
}).$mount('#app')
